module.exports = __webpack_public_path__ + "img/xdate_ddate.e89d00a.png";